export default "__VITE_ASSET__C2RGtUz9__"